// Style Imports
import Styles from './MultiTabEditor.module.scss';

// React Imports
import { useRef, useEffect, useState } from "react";

// Module Imports
import Editor from '@monaco-editor/react';

// Component Imports
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Tabs, Tab, Box, IconButton, Typography } from "@mui/material";
import { getFileLanguage } from '../filetypemapping';

// Context Imports
import { useMultiTabEditor } from '../../../contexts';

const MultiTabEditor = ({showToolsPane}) => {

    const editorRef = useRef(null);
    const { tabs, selectedTabIndex, handleTabChange, removeTab, handleEditorChange } = useMultiTabEditor()
    const [monacoInstance, setMonacoInstance] = useState(null);

    useEffect(() => {
        // Change the language dynamically when the selected tab changes
        if (editorRef.current && tabs[selectedTabIndex]) {
            const currentTab = tabs[selectedTabIndex];
            const language = getFileLanguage(currentTab.name); // Get language based on file name
            const model = editorRef.current.getModel(); // Get the current model of the editor

            if (model) {
                monacoInstance.editor.setModelLanguage(model, language); // Dynamically set the language
            }
        }
    }, [selectedTabIndex, tabs]);



    return (
        <div id='multiTabContainer' className={Styles.multiTabContainer}>
            <Tabs
                value={selectedTabIndex}
                onChange={handleTabChange}
                aria-label="file tabs"
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                    "& .Mui-selected": { backgroundColor: "white" },
                    "& .MuiTypography-root": { textOverflow: 'ellipsis', overflow: 'hidden', maxWidth: '15ch' }
                }}
                TabIndicatorProps={{
                    style: {
                        backgroundColor: "#ffffff"
                    }
                }}

            >
                {tabs?.map((file, index) => (
                    <Tab
                        key={file.path}
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: '500',
                                        textTransform: 'none', // Prevent uppercase transformation
                                    }}
                                >
                                    {file.name}
                                </Typography>
                                <IconButton
                                    sx={{ marginLeft: '8px', padding: '4px', fontSize: '1.2em' }}
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent tab switching on close
                                        removeTab(file.path);
                                    }}
                                >
                                    <HighlightOffIcon fontSize="inherit" />
                                </IconButton>
                            </Box>
                        }
                        id={`tab-${index}`}
                        aria-controls={`tabpanel-${index}`}
                        value={index}
                    />
                ))}
            </Tabs>

            {tabs.length > 0 && (
                <Editor
                    height={showToolsPane ? '59vh' : '99vh'}
                    value={tabs[selectedTabIndex]?.content || ''}
                    onChange={handleEditorChange}
                    onMount={(editor, monaco) => {
                        editorRef.current = editor;
                        setMonacoInstance(monaco)
                        const model = editor.getModel();
                        if (model) {
                        model.setEOL(monaco.editor.EndOfLineSequence.LF); // Force LF EOLs
                        }
                    }}
                    options={{
                        minimap: {
                            enabled: false,
                        },
                        scrollbar: {
                            // vertical: 'hidden',
                            // alwaysConsumeMouseWheel: false,
                        },
                        fontSize: 14,
                        glyphMargin: false,
                        folding: false,
                        lineDecorationsWidth: 10,
                        lineNumbersMinChars: 3,
                        glyphMarginDecorationLaneCount: 0,
                        // scrollBeyondLastLine: false,
                    }}
                />
            )}
        </div>
    );
};

export default MultiTabEditor;